import Body from './Body';
import Header from './Header';

const UserItem = {
  Header,
  Body,
};

export default UserItem;
